/**
 * @generated SignedSource<<3091e862cef87588d0454dc8081e50a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type blockquoteQuoteContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentShareWidgetContent">;
  readonly " $fragmentType": "blockquoteQuoteContent";
};
export type blockquoteQuoteContent$key = {
  readonly " $data"?: blockquoteQuoteContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"blockquoteQuoteContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "blockquoteQuoteContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentShareWidgetContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "f90b6ded129ebec779315142b1c3ea0e";

export default node;
